<template>
  <div>
    <b-card id="cardLogin" class="scale-in-bl">
      <b-form @submit="onSubmit" @reset="onReset" id="formRecover">
        <img
          src="../../assets/img/phoenix-logo.png"
          class="card-logo"
          alt="Phoenix Bioinformatics"
        />
        <h1 class="text-center mb-3">Password Reset</h1>
        <h2 class="text-center mb-4">Phoenix Bioinformatics Usage Portal</h2>
        <b-form-group id="input-group-1" label-for="email">
          <b-form-input
            id="email"
            class="input"
            v-model="form.email"
            type="email"
            placeholder="E-mail"
            required
          ></b-form-input>
        </b-form-group>
        <b-button type="submit" variant="primary" class="btn-block"
          >Send Password Email Reset</b-button
        >
      </b-form>
      <!-- Add a loading spinner -->
      <div v-if="loading" class="loading-box">
        <b-spinner variant="primary"></b-spinner> Loading...
      </div>

      <!-- Add a dynamic message box -->
      <div v-if="responseData.message" :class="['message-box', responseClass]">
        {{ responseData.message }}
      </div>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as login_types from "../../store/types_login";
import axios from 'axios';

const types = { ...login_types };
export default {
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      responseData: {},
      show: true,
      loading: false,
      errMsg: null,
      responseClass: ''
    };
  },
  computed: {
    ...mapGetters({
      stateLoggedinUser: types.USG_GET_USER,
    }),
  },
  watch: {},
  methods: {
    ...mapActions({
      stateLoginAction: types.USG_ACTION_RECOVER,
    }),
    async onSubmit(event) {
      event.preventDefault();
      this.responseData = {};
      this.errMsg = null;
      this.loading = true;
      try {
        const response = await axios.post('/auth/recover', {
          email: this.form.email
        });
        this.loading = false;
        if (response.status === 200) {
          this.responseData.message = 'A password reset link has been sent to your email. Please check your inbox.';
          this.responseClass = 'success';
        } else {
          this.responseData.message = 'An error occurred while sending the reset email. Please try again.';
          this.responseClass = 'failure';
        }
      } catch (error) {
        console.error(error);
        this.loading = false;
        this.responseData.message = 'An error occurred. Please try again.';
        this.responseClass = 'failure';
      }
    },
    onReset(event) {
      event.preventDefault();
      // Reset our form values
    },
    onChangeEmail(e) {
      // console.log(e);
      this.errMsg = null;
    },
    onChangePwd(e) {
      this.errMsg = null;
    },
  },
};
</script>

<style>
#cardLogin {
  width: 30%;
  margin: 0 auto;
  position: absolute;
  top: 25%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.error-msg {
  color: red;
  font-size: 14px;
}
h1 {
  font-size: 3em !important;
}
.input {
  font-size: 1.5em !important;
}
.mt-3.mb-3 {
  font-size: 1.5em !important;
}
.remember {
  height: 10px;
  width: 200px;
  vertical-align: middle;
}
.card-logo {
  position: absolute;
  top: 10px;
  right: 10px;
  /* width: 5%;
    height: 5%; */
}
body {
  background-color: #3d8cbc !important;
}

.loading-box {
  font-size: 18px;
  color: #333;
  text-align: center;
  margin-top: 20px;
}

.message-box {
  font-size: 18px;
  text-align: center;
  margin-top: 20px;
  padding: 15px;
  border-radius: 5px;
}

.success {
  background-color: #DFF2BF;
  color: #4F8A10;
}

.failure {
  background-color: #FFD2D2;
  color: #D8000C;
}
</style>



// WEBPACK FOOTER //
// src/components/login/Recover.vue